// Generated by tools/city-areas/generate-city-areas.mjs. Data © OpenStreetMap contributors, ODbL.
export interface CityArea {
  id: number;
  name: string;
  lat: number;
  lng: number;
}

export interface BigCity {
  ags: string;
  areas: CityArea[];
}

export const bigCityAreas: Record<string, BigCity> = {
  Berlin: {
    ags: '11000000',
    areas: [
      {
        id: 404538,
        name: 'Charlottenburg-Wilmersdorf',
        lat: 52.50107,
        lng: 13.27027,
      },
      {
        id: 55764,
        name: 'Friedrichshain-Kreuzberg',
        lat: 52.50384,
        lng: 13.42825,
      },
      {
        id: 404554,
        name: 'Lichtenberg',
        lat: 52.53496,
        lng: 13.50971,
      },
      {
        id: 164712,
        name: 'Marzahn-Hellersdorf',
        lat: 52.52104,
        lng: 13.57875,
      },
      {
        id: 16347,
        name: 'Mitte',
        lat: 52.53286,
        lng: 13.36589,
      },
      {
        id: 162902,
        name: 'Neukölln',
        lat: 52.44108,
        lng: 13.45504,
      },
      {
        id: 164723,
        name: 'Pankow',
        lat: 52.5971,
        lng: 13.44036,
      },
      {
        id: 16334,
        name: 'Reinickendorf',
        lat: 52.59563,
        lng: 13.29134,
      },
      {
        id: 16343,
        name: 'Spandau',
        lat: 52.52581,
        lng: 13.17882,
      },
      {
        id: 55734,
        name: 'Steglitz-Zehlendorf',
        lat: 52.43482,
        lng: 13.23914,
      },
      {
        id: 158437,
        name: 'Tempelhof-Schöneberg',
        lat: 52.44116,
        lng: 13.38076,
      },
      {
        id: 55754,
        name: 'Treptow-Köpenick',
        lat: 52.42963,
        lng: 13.61123,
      },
    ],
  },
  Hamburg: {
    ags: '02000000',
    areas: [
      {
        id: 30223,
        name: 'Altona',
        lat: 53.57357,
        lng: 9.84255,
      },
      {
        id: 28936,
        name: 'Bergedorf',
        lat: 53.46134,
        lng: 10.17416,
      },
      {
        id: 30243,
        name: 'Eimsbüttel',
        lat: 53.60958,
        lng: 9.93973,
      },
      {
        id: 28971,
        name: 'Hamburg-Mitte',
        lat: 53.52694,
        lng: 9.99727,
      },
      {
        id: 30352,
        name: 'Hamburg-Nord',
        lat: 53.61768,
        lng: 10.01654,
      },
      {
        id: 28964,
        name: 'Harburg',
        lat: 53.47529,
        lng: 9.90148,
      },
      {
        id: 30353,
        name: 'Wandsbek',
        lat: 53.64162,
        lng: 10.11915,
      },
    ],
  },
  München: {
    ags: '09162000',
    areas: [
      {
        id: 54383,
        name: 'Allach-Untermenzing',
        lat: 48.193,
        lng: 11.46331,
      },
      {
        id: 56391,
        name: 'Altstadt-Lehel',
        lat: 48.14108,
        lng: 11.58254,
      },
      {
        id: 56393,
        name: 'Au-Haidhausen',
        lat: 48.12981,
        lng: 11.59531,
      },
      {
        id: 54382,
        name: 'Aubing-Lochhausen-Langwied',
        lat: 48.16546,
        lng: 11.4091,
      },
      {
        id: 56394,
        name: 'Berg am Laim',
        lat: 48.12685,
        lng: 11.63238,
      },
      {
        id: 56392,
        name: 'Bogenhausen',
        lat: 48.15814,
        lng: 11.64326,
      },
      {
        id: 54384,
        name: 'Feldmoching-Hasenbergl',
        lat: 48.21519,
        lng: 11.52233,
      },
      {
        id: 54376,
        name: 'Hadern',
        lat: 48.11398,
        lng: 11.48346,
      },
      {
        id: 54388,
        name: 'Laim',
        lat: 48.13625,
        lng: 11.50473,
      },
      {
        id: 54392,
        name: 'Ludwigsvorstadt-Isarvorstadt',
        lat: 48.13038,
        lng: 11.56152,
      },
      {
        id: 56388,
        name: 'Maxvorstadt',
        lat: 48.14854,
        lng: 11.56468,
      },
      {
        id: 56387,
        name: 'Milbertshofen-Am Hart',
        lat: 48.19626,
        lng: 11.56826,
      },
      {
        id: 54385,
        name: 'Moosach',
        lat: 48.18181,
        lng: 11.51116,
      },
      {
        id: 54387,
        name: 'Neuhausen-Nymphenburg',
        lat: 48.15638,
        lng: 11.51913,
      },
      {
        id: 2313918,
        name: 'Obergiesing-Fasangarten',
        lat: 48.10268,
        lng: 11.59332,
      },
      {
        id: 54379,
        name: 'Pasing-Obermenzing',
        lat: 48.15337,
        lng: 11.46349,
      },
      {
        id: 56397,
        name: 'Ramersdorf-Perlach',
        lat: 48.09977,
        lng: 11.63888,
      },
      {
        id: 56390,
        name: 'Schwabing-Freimann',
        lat: 48.19279,
        lng: 11.61054,
      },
      {
        id: 56389,
        name: 'Schwabing-West',
        lat: 48.16624,
        lng: 11.56868,
      },
      {
        id: 54390,
        name: 'Schwanthalerhöhe',
        lat: 48.1361,
        lng: 11.53863,
      },
      {
        id: 54393,
        name: 'Sendling',
        lat: 48.11473,
        lng: 11.54732,
      },
      {
        id: 54375,
        name: 'Sendling-Westpark',
        lat: 48.11681,
        lng: 11.5199,
      },
      {
        id: 54373,
        name: 'Thalkirchen-Obersendling-Forstenried-Fürstenried-Solln',
        lat: 48.08673,
        lng: 11.5135,
      },
      {
        id: 52747,
        name: 'Trudering-Riem',
        lat: 48.12405,
        lng: 11.68372,
      },
      {
        id: 56395,
        name: 'Untergiesing-Harlaching',
        lat: 48.09778,
        lng: 11.56443,
      },
    ],
  },
  Köln: {
    ags: '05315000',
    areas: [
      {
        id: 2613796,
        name: 'Chorweiler',
        lat: 51.03521,
        lng: 6.87477,
      },
      {
        id: 2613797,
        name: 'Ehrenfeld',
        lat: 50.96786,
        lng: 6.89016,
      },
      {
        id: 2613798,
        name: 'Innenstadt',
        lat: 50.937,
        lng: 6.95958,
      },
      {
        id: 2613800,
        name: 'Kalk',
        lat: 50.93527,
        lng: 7.06552,
      },
      {
        id: 2613801,
        name: 'Lindenthal',
        lat: 50.93349,
        lng: 6.87226,
      },
      {
        id: 2613802,
        name: 'Mülheim',
        lat: 50.98472,
        lng: 7.02983,
      },
      {
        id: 2613803,
        name: 'Nippes',
        lat: 50.98588,
        lng: 6.94612,
      },
      {
        id: 2613804,
        name: 'Porz',
        lat: 50.88082,
        lng: 7.07176,
      },
      {
        id: 2613805,
        name: 'Rodenkirchen',
        lat: 50.87701,
        lng: 6.97065,
      },
    ],
  },
  'Frankfurt am Main': {
    ags: '06412000',
    areas: [
      {
        id: 4012826,
        name: 'Bergen-Enkheim',
        lat: 50.15912,
        lng: 8.76683,
      },
      {
        id: 11042430,
        name: 'Bornheim/Ostend',
        lat: 50.12068,
        lng: 8.71691,
      },
      {
        id: 3339944,
        name: 'Harheim',
        lat: 50.18583,
        lng: 8.68984,
      },
      {
        id: 11042433,
        name: 'Innenstadt 1',
        lat: 50.10428,
        lng: 8.65103,
      },
      {
        id: 11042432,
        name: 'Innenstadt 2',
        lat: 50.12118,
        lng: 8.64342,
      },
      {
        id: 11042431,
        name: 'Innenstadt 3',
        lat: 50.12925,
        lng: 8.68889,
      },
      {
        id: 3342010,
        name: 'Kalbach-Riedberg',
        lat: 50.18469,
        lng: 8.63908,
      },
      {
        id: 11042425,
        name: 'Mitte-Nord',
        lat: 50.15033,
        lng: 8.65908,
      },
      {
        id: 11042427,
        name: 'Mitte-West',
        lat: 50.13665,
        lng: 8.61159,
      },
      {
        id: 3299379,
        name: 'Nieder-Erlenbach',
        lat: 50.20873,
        lng: 8.70923,
      },
      {
        id: 3342011,
        name: 'Nieder-Eschbach',
        lat: 50.2011,
        lng: 8.6682,
      },
      {
        id: 11042424,
        name: 'Nord-Ost',
        lat: 50.16369,
        lng: 8.6884,
      },
      {
        id: 11042426,
        name: 'Nord-West',
        lat: 50.1646,
        lng: 8.62287,
      },
      {
        id: 11042423,
        name: 'Ost',
        lat: 50.13644,
        lng: 8.74271,
      },
      {
        id: 11042429,
        name: 'Süd',
        lat: 50.06658,
        lng: 8.63756,
      },
      {
        id: 11042428,
        name: 'West',
        lat: 50.0961,
        lng: 8.55401,
      },
    ],
  },
  Stuttgart: {
    ags: '08111000',
    areas: [
      {
        id: 1107864,
        name: 'Bad Cannstatt',
        lat: 48.80865,
        lng: 9.22302,
      },
      {
        id: 1107931,
        name: 'Birkach',
        lat: 48.72584,
        lng: 9.20452,
      },
      {
        id: 1107904,
        name: 'Botnang',
        lat: 48.77914,
        lng: 9.12611,
      },
      {
        id: 1107796,
        name: 'Degerloch',
        lat: 48.7446,
        lng: 9.17589,
      },
      {
        id: 1107785,
        name: 'Feuerbach',
        lat: 48.80517,
        lng: 9.14639,
      },
      {
        id: 1107853,
        name: 'Hedelfingen',
        lat: 48.75744,
        lng: 9.24247,
      },
      {
        id: 1107824,
        name: 'Möhringen',
        lat: 48.72459,
        lng: 9.14936,
      },
      {
        id: 1107892,
        name: 'Mühlhausen',
        lat: 48.84424,
        lng: 9.22103,
      },
      {
        id: 1107846,
        name: 'Münster',
        lat: 48.82387,
        lng: 9.20947,
      },
      {
        id: 1107914,
        name: 'Obertürkheim',
        lat: 48.77453,
        lng: 9.28332,
      },
      {
        id: 1107885,
        name: 'Plieningen',
        lat: 48.70734,
        lng: 9.205,
      },
      {
        id: 1107777,
        name: 'Sillenbuch',
        lat: 48.74466,
        lng: 9.22084,
      },
      {
        id: 1107941,
        name: 'Stammheim',
        lat: 48.84952,
        lng: 9.15224,
      },
      {
        id: 1107850,
        name: 'Stuttgart-Mitte',
        lat: 48.7791,
        lng: 9.18125,
      },
      {
        id: 1107840,
        name: 'Stuttgart-Nord',
        lat: 48.79614,
        lng: 9.17399,
      },
      {
        id: 1107908,
        name: 'Stuttgart-Ost',
        lat: 48.7784,
        lng: 9.20852,
      },
      {
        id: 1107879,
        name: 'Stuttgart-Süd',
        lat: 48.75673,
        lng: 9.15382,
      },
      {
        id: 1107770,
        name: 'Stuttgart-West',
        lat: 48.77523,
        lng: 9.11565,
      },
      {
        id: 1107836,
        name: 'Untertürkheim',
        lat: 48.78466,
        lng: 9.25904,
      },
      {
        id: 1107807,
        name: 'Vaihingen',
        lat: 48.73663,
        lng: 9.09239,
      },
      {
        id: 1107875,
        name: 'Wangen',
        lat: 48.77226,
        lng: 9.23789,
      },
      {
        id: 1107829,
        name: 'Weilimdorf',
        lat: 48.81328,
        lng: 9.10781,
      },
      {
        id: 1107897,
        name: 'Zuffenhausen',
        lat: 48.83439,
        lng: 9.17329,
      },
    ],
  },
  Düsseldorf: {
    ags: '05111000',
    areas: [
      {
        id: 91066,
        name: 'Stadtbezirk 1',
        lat: 51.2414,
        lng: 6.77882,
      },
      {
        id: 76175,
        name: 'Stadtbezirk 10',
        lat: 51.14037,
        lng: 6.90257,
      },
      {
        id: 91148,
        name: 'Stadtbezirk 2',
        lat: 51.23205,
        lng: 6.81367,
      },
      {
        id: 92370,
        name: 'Stadtbezirk 3',
        lat: 51.20325,
        lng: 6.76839,
      },
      {
        id: 89742,
        name: 'Stadtbezirk 4',
        lat: 51.23665,
        lng: 6.73521,
      },
      {
        id: 93513,
        name: 'Stadtbezirk 5',
        lat: 51.30521,
        lng: 6.75848,
      },
      {
        id: 91322,
        name: 'Stadtbezirk 6',
        lat: 51.26785,
        lng: 6.81109,
      },
      {
        id: 75732,
        name: 'Stadtbezirk 7',
        lat: 51.24797,
        lng: 6.87795,
      },
      {
        id: 58343,
        name: 'Stadtbezirk 8',
        lat: 51.20204,
        lng: 6.86572,
      },
      {
        id: 93380,
        name: 'Stadtbezirk 9',
        lat: 51.1651,
        lng: 6.84821,
      },
    ],
  },
  Leipzig: {
    ags: '14713000',
    areas: [
      {
        id: 1395225,
        name: 'Altwest',
        lat: 51.34884,
        lng: 12.2911,
      },
      {
        id: 3351884,
        name: 'Mitte',
        lat: 51.34029,
        lng: 12.37153,
      },
      {
        id: 1395306,
        name: 'Nord',
        lat: 51.40255,
        lng: 12.40503,
      },
      {
        id: 1395309,
        name: 'Nordost',
        lat: 51.38058,
        lng: 12.43173,
      },
      {
        id: 1395278,
        name: 'Nordwest',
        lat: 51.39069,
        lng: 12.31061,
      },
      {
        id: 1395337,
        name: 'Ost',
        lat: 51.33665,
        lng: 12.47572,
      },
      {
        id: 1395351,
        name: 'Süd',
        lat: 51.30257,
        lng: 12.38036,
      },
      {
        id: 1395341,
        name: 'Südost',
        lat: 51.29877,
        lng: 12.45405,
      },
      {
        id: 1395369,
        name: 'Südwest',
        lat: 51.28291,
        lng: 12.30307,
      },
      {
        id: 1395406,
        name: 'West',
        lat: 51.31802,
        lng: 12.27213,
      },
    ],
  },
  Dortmund: {
    ags: '05913000',
    areas: [
      {
        id: 10086667,
        name: 'Aplerbeck',
        lat: 51.48702,
        lng: 7.55995,
      },
      {
        id: 10086668,
        name: 'Brackel',
        lat: 51.52686,
        lng: 7.57547,
      },
      {
        id: 10086670,
        name: 'Eving',
        lat: 51.56481,
        lng: 7.46601,
      },
      {
        id: 10086665,
        name: 'Hombruch',
        lat: 51.46497,
        lng: 7.43857,
      },
      {
        id: 10086666,
        name: 'Hörde',
        lat: 51.45706,
        lng: 7.50184,
      },
      {
        id: 10086544,
        name: 'Huckarde',
        lat: 51.53194,
        lng: 7.3985,
      },
      {
        id: 10086664,
        name: 'Innenstadt Nord',
        lat: 51.53219,
        lng: 7.47178,
      },
      {
        id: 10086663,
        name: 'Innenstadt Ost',
        lat: 51.50642,
        lng: 7.49011,
      },
      {
        id: 10086662,
        name: 'Innenstadt West',
        lat: 51.50727,
        lng: 7.43259,
      },
      {
        id: 10035847,
        name: 'Lütgendortmund',
        lat: 51.50179,
        lng: 7.35549,
      },
      {
        id: 10086543,
        name: 'Mengede',
        lat: 51.56573,
        lng: 7.38775,
      },
      {
        id: 10086669,
        name: 'Scharnhorst',
        lat: 51.56126,
        lng: 7.55008,
      },
    ],
  },
  Essen: {
    ags: '05113000',
    areas: [
      {
        id: 5928878,
        name: 'Stadtbezirk I',
        lat: 51.45719,
        lng: 7.02236,
      },
      {
        id: 7076843,
        name: 'Stadtbezirk II',
        lat: 51.42841,
        lng: 7.02674,
      },
      {
        id: 7076842,
        name: 'Stadtbezirk III',
        lat: 51.43653,
        lng: 6.96979,
      },
      {
        id: 7076839,
        name: 'Stadtbezirk IV',
        lat: 51.47768,
        lng: 6.94259,
      },
      {
        id: 7076837,
        name: 'Stadtbezirk IX',
        lat: 51.38303,
        lng: 6.98793,
      },
      {
        id: 7076840,
        name: 'Stadtbezirk V',
        lat: 51.50045,
        lng: 7.00554,
      },
      {
        id: 7076841,
        name: 'Stadtbezirk VI',
        lat: 51.48705,
        lng: 7.04612,
      },
      {
        id: 7076838,
        name: 'Stadtbezirk VII',
        lat: 51.45501,
        lng: 7.09236,
      },
      {
        id: 7076844,
        name: 'Stadtbezirk VIII',
        lat: 51.40436,
        lng: 7.08583,
      },
    ],
  },
  Bremen: {
    ags: '04011000',
    areas: [
      {
        id: 1135978,
        name: 'Bremen-Mitte',
        lat: 53.15074,
        lng: 8.67677,
      },
      {
        id: 1114208,
        name: 'Bremen-Nord',
        lat: 53.17872,
        lng: 8.61967,
      },
      {
        id: 1130801,
        name: 'Bremen-Ost',
        lat: 53.08249,
        lng: 8.90609,
      },
      {
        id: 1136099,
        name: 'Bremen-Süd',
        lat: 53.06678,
        lng: 8.76337,
      },
      {
        id: 1943540,
        name: 'Bremen-West',
        lat: 53.12933,
        lng: 8.78955,
      },
    ],
  },
  Dresden: {
    ags: '14612000',
    areas: [
      {
        id: 192979,
        name: 'Altfranken',
        lat: 51.03459,
        lng: 13.64351,
      },
      {
        id: 192900,
        name: 'Altstadt',
        lat: 51.05272,
        lng: 13.73699,
      },
      {
        id: 192924,
        name: 'Blasewitz',
        lat: 51.03729,
        lng: 13.79849,
      },
      {
        id: 192988,
        name: 'Cossebaude',
        lat: 51.0897,
        lng: 13.62559,
      },
      {
        id: 192965,
        name: 'Cotta',
        lat: 51.04811,
        lng: 13.6751,
      },
      {
        id: 192980,
        name: 'Gompitz',
        lat: 51.04932,
        lng: 13.61408,
      },
      {
        id: 192915,
        name: 'Klotzsche',
        lat: 51.11745,
        lng: 13.75282,
      },
      {
        id: 192995,
        name: 'Langebrück',
        lat: 51.13337,
        lng: 13.84155,
      },
      {
        id: 192930,
        name: 'Leuben',
        lat: 51.0065,
        lng: 13.84477,
      },
      {
        id: 192921,
        name: 'Loschwitz',
        lat: 51.0781,
        lng: 13.84516,
      },
      {
        id: 192990,
        name: 'Mobschatz',
        lat: 51.06773,
        lng: 13.629,
      },
      {
        id: 192901,
        name: 'Neustadt',
        lat: 51.07554,
        lng: 13.76261,
      },
      {
        id: 192989,
        name: 'Oberwartha',
        lat: 51.07705,
        lng: 13.59944,
      },
      {
        id: 192910,
        name: 'Pieschen',
        lat: 51.08543,
        lng: 13.7026,
      },
      {
        id: 192952,
        name: 'Plauen',
        lat: 51.02052,
        lng: 13.72144,
      },
      {
        id: 192949,
        name: 'Prohlis',
        lat: 51.00136,
        lng: 13.79248,
      },
      {
        id: 192994,
        name: 'Schönborn',
        lat: 51.14668,
        lng: 13.86538,
      },
      {
        id: 192923,
        name: 'Schönfeld-Weißig',
        lat: 51.04213,
        lng: 13.90757,
      },
      {
        id: 191635,
        name: 'Weixdorf',
        lat: 51.15354,
        lng: 13.78597,
      },
    ],
  },
  Hannover: {
    ags: '03241001',
    areas: [
      {
        id: 1864056,
        name: 'Ahlem-Badenstedt-Davenstedt',
        lat: 52.36685,
        lng: 9.66672,
      },
      {
        id: 1863265,
        name: 'Bothfeld-Vahrenheide',
        lat: 52.42355,
        lng: 9.8005,
      },
      {
        id: 1862974,
        name: 'Buchholz-Kleefeld',
        lat: 52.38513,
        lng: 9.80544,
      },
      {
        id: 1863402,
        name: 'Döhren-Wülfel',
        lat: 52.33477,
        lng: 9.78516,
      },
      {
        id: 1863547,
        name: 'Herrenhausen-Stöcken',
        lat: 52.41047,
        lng: 9.66181,
      },
      {
        id: 1863359,
        name: 'Kirchrode-Bemerode-Wülferode',
        lat: 52.33823,
        lng: 9.83771,
      },
      {
        id: 1864095,
        name: 'Linden-Limmer',
        lat: 52.36824,
        lng: 9.70008,
      },
      {
        id: 1862329,
        name: 'Misburg-Anderten',
        lat: 52.38238,
        lng: 9.86386,
      },
      {
        id: 80107,
        name: 'Mitte',
        lat: 52.37823,
        lng: 9.75365,
      },
      {
        id: 1863490,
        name: 'Nord',
        lat: 52.40575,
        lng: 9.71169,
      },
      {
        id: 1863993,
        name: 'Ricklingen',
        lat: 52.33747,
        lng: 9.70645,
      },
      {
        id: 1863419,
        name: 'Südstadt-Bult',
        lat: 52.35974,
        lng: 9.75826,
      },
      {
        id: 80152,
        name: 'Vahrenwald-List',
        lat: 52.39874,
        lng: 9.74749,
      },
    ],
  },
  Nürnberg: {
    ags: '09564000',
    areas: [
      {
        id: 7499871,
        name: 'Altstadt und engere Innenstadt',
        lat: 49.45281,
        lng: 11.07662,
      },
      {
        id: 20021787,
        name: 'Nordöstliche Außenstadt',
        lat: 49.48949,
        lng: 11.1021,
      },
      {
        id: 20021788,
        name: 'Nordwestliche Außenstadt',
        lat: 49.50135,
        lng: 11.03906,
      },
      {
        id: 20021786,
        name: 'Östliche Außenstadt',
        lat: 49.46145,
        lng: 11.16931,
      },
      {
        id: 20021791,
        name: 'Südliche Außenstadt',
        lat: 49.38425,
        lng: 11.07684,
      },
      {
        id: 20021792,
        name: 'Südöstliche Außenstadt',
        lat: 49.40842,
        lng: 11.14134,
      },
      {
        id: 20021790,
        name: 'Südwestliche Außenstadt',
        lat: 49.3998,
        lng: 11.0275,
      },
      {
        id: 7551164,
        name: 'Weiterer Innenstadtgürtel Süd',
        lat: 49.43703,
        lng: 11.08253,
      },
      {
        id: 20021793,
        name: 'Weiterer Innenstadtgürtel West/Nord/Ost',
        lat: 49.46251,
        lng: 11.07548,
      },
      {
        id: 20021789,
        name: 'Westliche Außenstadt',
        lat: 49.44466,
        lng: 11.01843,
      },
    ],
  },
  Duisburg: {
    ags: '05112000',
    areas: [
      {
        id: 1357946,
        name: 'Duisburg-Mitte',
        lat: 51.42295,
        lng: 6.77178,
      },
      {
        id: 1357947,
        name: 'Duisburg-Süd',
        lat: 51.3656,
        lng: 6.7486,
      },
      {
        id: 1357922,
        name: 'Hamborn',
        lat: 51.50103,
        lng: 6.77362,
      },
      {
        id: 1350346,
        name: 'Homberg/Ruhrort/Baerl',
        lat: 51.47203,
        lng: 6.69136,
      },
      {
        id: 1357936,
        name: 'Meiderich/Beeck',
        lat: 51.4732,
        lng: 6.75475,
      },
      {
        id: 1350280,
        name: 'Rheinhausen',
        lat: 51.40351,
        lng: 6.69059,
      },
      {
        id: 1357886,
        name: 'Walsum',
        lat: 51.53295,
        lng: 6.72398,
      },
    ],
  },
  Bochum: {
    ags: '05911000',
    areas: [
      {
        id: 1647370,
        name: 'Bochum-Mitte',
        lat: 51.48913,
        lng: 7.20782,
      },
      {
        id: 1647366,
        name: 'Bochum-Nord',
        lat: 51.50751,
        lng: 7.27232,
      },
      {
        id: 1647360,
        name: 'Bochum-Ost',
        lat: 51.47569,
        lng: 7.30628,
      },
      {
        id: 1647350,
        name: 'Bochum-Süd',
        lat: 51.4396,
        lng: 7.24415,
      },
      {
        id: 1647346,
        name: 'Bochum-Südwest',
        lat: 51.43749,
        lng: 7.17847,
      },
      {
        id: 1647338,
        name: 'Bochum-Wattenscheid',
        lat: 51.46899,
        lng: 7.14504,
      },
    ],
  },
  Wuppertal: {
    ags: '05124000',
    areas: [
      {
        id: 18728688,
        name: 'Barmen',
        lat: 51.26753,
        lng: 7.18487,
      },
      {
        id: 18727680,
        name: 'Cronenberg',
        lat: 51.20585,
        lng: 7.13376,
      },
      {
        id: 18728903,
        name: 'Elberfeld',
        lat: 51.24723,
        lng: 7.14862,
      },
      {
        id: 18728947,
        name: 'Elberfeld-West',
        lat: 51.24772,
        lng: 7.10864,
      },
      {
        id: 18728521,
        name: 'Heckinghausen',
        lat: 51.26132,
        lng: 7.21612,
      },
      {
        id: 18727945,
        name: 'Langerfeld-Beyenburg',
        lat: 51.24518,
        lng: 7.2664,
      },
      {
        id: 18728045,
        name: 'Oberbarmen',
        lat: 51.29474,
        lng: 7.23295,
      },
      {
        id: 18728811,
        name: 'Uellendahl-Katernberg',
        lat: 51.28533,
        lng: 7.13092,
      },
      {
        id: 18730488,
        name: 'Vohwinkel',
        lat: 51.2376,
        lng: 7.06413,
      },
    ],
  },
  Bielefeld: {
    ags: '05711000',
    areas: [
      {
        id: 976442,
        name: 'Brackwede',
        lat: 51.97858,
        lng: 8.46522,
      },
      {
        id: 976440,
        name: 'Dornberg',
        lat: 52.05013,
        lng: 8.4715,
      },
      {
        id: 976439,
        name: 'Gadderbaum',
        lat: 52.00705,
        lng: 8.51719,
      },
      {
        id: 975261,
        name: 'Heepen',
        lat: 52.04268,
        lng: 8.61298,
      },
      {
        id: 974940,
        name: 'Jöllenbeck',
        lat: 52.08616,
        lng: 8.52685,
      },
      {
        id: 976404,
        name: 'Mitte',
        lat: 52.02636,
        lng: 8.55258,
      },
      {
        id: 976422,
        name: 'Schildesche',
        lat: 52.04628,
        lng: 8.52655,
      },
      {
        id: 976441,
        name: 'Senne',
        lat: 51.95723,
        lng: 8.53152,
      },
      {
        id: 976380,
        name: 'Sennestadt',
        lat: 51.94269,
        lng: 8.58791,
      },
      {
        id: 976364,
        name: 'Stieghorst',
        lat: 51.98981,
        lng: 8.60751,
      },
    ],
  },
  Bonn: {
    ags: '05314000',
    areas: [
      {
        id: 55070,
        name: 'Bad Godesberg',
        lat: 50.67673,
        lng: 7.15246,
      },
      {
        id: 2110212,
        name: 'Bonn-Beuel',
        lat: 50.73945,
        lng: 7.15008,
      },
      {
        id: 55071,
        name: 'Hardtberg',
        lat: 50.70577,
        lng: 7.05137,
      },
      {
        id: 2121824,
        name: 'Stadtbezirk Bonn',
        lat: 50.70292,
        lng: 7.07834,
      },
    ],
  },
  Münster: {
    ags: '05515000',
    areas: [
      {
        id: 3853922,
        name: 'Münster-Hiltrup',
        lat: 51.88943,
        lng: 7.61373,
      },
      {
        id: 3853894,
        name: 'Münster-Mitte',
        lat: 51.96079,
        lng: 7.6266,
      },
      {
        id: 3854699,
        name: 'Münster-Nord',
        lat: 52.01744,
        lng: 7.61848,
      },
      {
        id: 3718923,
        name: 'Münster-Ost',
        lat: 51.99123,
        lng: 7.69514,
      },
      {
        id: 3718924,
        name: 'Münster-Südost',
        lat: 51.9264,
        lng: 7.71025,
      },
      {
        id: 3854700,
        name: 'Münster-West',
        lat: 51.96786,
        lng: 7.54897,
      },
    ],
  },
  Mannheim: {
    ags: '08222000',
    areas: [
      {
        id: 2800523,
        name: 'Feudenheim',
        lat: 49.48866,
        lng: 8.52843,
      },
      {
        id: 3286562,
        name: 'Friedrichsfeld',
        lat: 49.43378,
        lng: 8.5689,
      },
      {
        id: 3286563,
        name: 'Innenstadt/Jungbusch',
        lat: 49.49286,
        lng: 8.45635,
      },
      {
        id: 2796949,
        name: 'Käfertal',
        lat: 49.51835,
        lng: 8.52133,
      },
      {
        id: 3286564,
        name: 'Lindenhof',
        lat: 49.47138,
        lng: 8.46993,
      },
      {
        id: 3286565,
        name: 'Neckarau',
        lat: 49.45448,
        lng: 8.47813,
      },
      {
        id: 3286566,
        name: 'Neckarstadt-Ost',
        lat: 49.49912,
        lng: 8.48965,
      },
      {
        id: 3286567,
        name: 'Neckarstadt-West',
        lat: 49.51847,
        lng: 8.45186,
      },
      {
        id: 3286568,
        name: 'Neuostheim/Neuhermsheim',
        lat: 49.47116,
        lng: 8.51881,
      },
      {
        id: 3286569,
        name: 'Rheinau',
        lat: 49.43308,
        lng: 8.52813,
      },
      {
        id: 3286570,
        name: 'Sandhofen',
        lat: 49.56243,
        lng: 8.45455,
      },
      {
        id: 2801254,
        name: 'Schönau',
        lat: 49.54507,
        lng: 8.47286,
      },
      {
        id: 3286571,
        name: 'Schwetzingerstadt/Oststadt',
        lat: 49.48055,
        lng: 8.48834,
      },
      {
        id: 3286572,
        name: 'Seckenheim',
        lat: 49.45989,
        lng: 8.55056,
      },
      {
        id: 2796746,
        name: 'Vogelstang',
        lat: 49.51147,
        lng: 8.54475,
      },
      {
        id: 2801091,
        name: 'Waldhof',
        lat: 49.53513,
        lng: 8.49614,
      },
      {
        id: 270096,
        name: 'Wallstadt',
        lat: 49.50486,
        lng: 8.56367,
      },
    ],
  },
  Augsburg: {
    ags: '09761000',
    areas: [
      {
        id: 381660,
        name: 'Antonsviertel',
        lat: 48.35421,
        lng: 10.88499,
      },
      {
        id: 382586,
        name: 'Bärenkeller',
        lat: 48.39729,
        lng: 10.8553,
      },
      {
        id: 384191,
        name: 'Bergheim',
        lat: 48.32124,
        lng: 10.80765,
      },
      {
        id: 382397,
        name: 'Firnhaberau',
        lat: 48.42762,
        lng: 10.89635,
      },
      {
        id: 391238,
        name: 'Göggingen',
        lat: 48.336,
        lng: 10.86468,
      },
      {
        id: 448070,
        name: 'Hammerschmiede',
        lat: 48.41045,
        lng: 10.91735,
      },
      {
        id: 3649737,
        name: 'Haunstetten-Siebenbrunn',
        lat: 48.30271,
        lng: 10.9194,
      },
      {
        id: 415860,
        name: 'Hochfeld',
        lat: 48.34768,
        lng: 10.9,
      },
      {
        id: 3649726,
        name: 'Hochzoll',
        lat: 48.34881,
        lng: 10.94484,
      },
      {
        id: 3649746,
        name: 'Innenstadt',
        lat: 48.36841,
        lng: 10.90363,
      },
      {
        id: 384192,
        name: 'Inningen',
        lat: 48.30705,
        lng: 10.85375,
      },
      {
        id: 381692,
        name: 'Kriegshaber',
        lat: 48.37926,
        lng: 10.85517,
      },
      {
        id: 535045,
        name: 'Lechhausen',
        lat: 48.3829,
        lng: 10.93218,
      },
      {
        id: 3649439,
        name: 'Oberhausen',
        lat: 48.39159,
        lng: 10.88137,
      },
      {
        id: 3649712,
        name: 'Pfersee',
        lat: 48.36181,
        lng: 10.86831,
      },
      {
        id: 3649733,
        name: 'Spickel-Herrenbach',
        lat: 48.35162,
        lng: 10.92227,
      },
      {
        id: 381624,
        name: 'Universitätsviertel',
        lat: 48.33149,
        lng: 10.89339,
      },
    ],
  },
  Wiesbaden: {
    ags: '06414000',
    areas: [
      {
        id: 4278975,
        name: 'Auringen',
        lat: 50.12367,
        lng: 8.32591,
      },
      {
        id: 5408628,
        name: 'Biebrich',
        lat: 50.04814,
        lng: 8.23712,
      },
      {
        id: 4519638,
        name: 'Bierstadt',
        lat: 50.0843,
        lng: 8.28645,
      },
      {
        id: 4278976,
        name: 'Breckenheim',
        lat: 50.08523,
        lng: 8.36894,
      },
      {
        id: 4519639,
        name: 'Delkenheim',
        lat: 50.04025,
        lng: 8.34426,
      },
      {
        id: 5408629,
        name: 'Dotzheim',
        lat: 50.08752,
        lng: 8.17187,
      },
      {
        id: 4519640,
        name: 'Erbenheim',
        lat: 50.05492,
        lng: 8.30088,
      },
      {
        id: 5408630,
        name: 'Frauenstein',
        lat: 50.07591,
        lng: 8.14349,
      },
      {
        id: 4519641,
        name: 'Heßloch',
        lat: 50.10907,
        lng: 8.29361,
      },
      {
        id: 4519642,
        name: 'Igstadt',
        lat: 50.0862,
        lng: 8.33085,
      },
      {
        id: 3897893,
        name: 'Klarenthal',
        lat: 50.10084,
        lng: 8.18698,
      },
      {
        id: 4519637,
        name: 'Kloppenheim',
        lat: 50.09795,
        lng: 8.31183,
      },
      {
        id: 5408631,
        name: 'Mainz-Amöneburg',
        lat: 50.03402,
        lng: 8.26363,
      },
      {
        id: 4519643,
        name: 'Mainz-Kastel',
        lat: 50.02437,
        lng: 8.28528,
      },
      {
        id: 4519644,
        name: 'Mainz-Kostheim',
        lat: 50.01219,
        lng: 8.31114,
      },
      {
        id: 4278977,
        name: 'Medenbach',
        lat: 50.10906,
        lng: 8.34424,
      },
      {
        id: 3897825,
        name: 'Mitte',
        lat: 50.07995,
        lng: 8.23878,
      },
      {
        id: 4278978,
        name: 'Naurod',
        lat: 50.13296,
        lng: 8.30209,
      },
      {
        id: 5408632,
        name: 'Nordenstadt',
        lat: 50.06264,
        lng: 8.34166,
      },
      {
        id: 3897896,
        name: 'Nordost',
        lat: 50.10866,
        lng: 8.22105,
      },
      {
        id: 4278979,
        name: 'Rambach',
        lat: 50.12883,
        lng: 8.26857,
      },
      {
        id: 3897850,
        name: 'Rheingauviertel / Hollerborn',
        lat: 50.07858,
        lng: 8.21755,
      },
      {
        id: 5408633,
        name: 'Schierstein',
        lat: 50.04745,
        lng: 8.19101,
      },
      {
        id: 4278980,
        name: 'Sonnenberg',
        lat: 50.11574,
        lng: 8.25269,
      },
      {
        id: 3898238,
        name: 'Südost',
        lat: 50.06876,
        lng: 8.25525,
      },
      {
        id: 3897826,
        name: 'Westend / Bleichstraße',
        lat: 50.08163,
        lng: 8.2287,
      },
    ],
  },
  Mönchengladbach: {
    ags: '05116000',
    areas: [
      {
        id: 13130198,
        name: 'Nord',
        lat: 51.20223,
        lng: 6.38758,
      },
      {
        id: 13129768,
        name: 'Ost',
        lat: 51.1948,
        lng: 6.4823,
      },
      {
        id: 13132801,
        name: 'Süd',
        lat: 51.14964,
        lng: 6.44627,
      },
      {
        id: 13132693,
        name: 'West',
        lat: 51.14235,
        lng: 6.37392,
      },
    ],
  },
  Gelsenkirchen: {
    ags: '05513000',
    areas: [
      {
        id: 53944,
        name: 'Gelsenkirchen-Mitte',
        lat: 51.52301,
        lng: 7.08892,
      },
      {
        id: 53929,
        name: 'Gelsenkirchen-Nord',
        lat: 51.59494,
        lng: 7.0383,
      },
      {
        id: 53939,
        name: 'Gelsenkirchen-Ost',
        lat: 51.56612,
        lng: 7.10101,
      },
      {
        id: 53942,
        name: 'Gelsenkirchen-Süd',
        lat: 51.49581,
        lng: 7.10674,
      },
      {
        id: 53938,
        name: 'Gelsenkirchen-West',
        lat: 51.54385,
        lng: 7.03792,
      },
    ],
  },
  Aachen: {
    ags: '05334002',
    areas: [
      {
        id: 22146,
        name: 'Aachen-Mitte',
        lat: 50.75589,
        lng: 6.0928,
      },
      {
        id: 21908,
        name: 'Brand',
        lat: 50.7524,
        lng: 6.17231,
      },
      {
        id: 21917,
        name: 'Eilendorf',
        lat: 50.77638,
        lng: 6.15829,
      },
      {
        id: 21918,
        name: 'Haaren',
        lat: 50.79686,
        lng: 6.15189,
      },
      {
        id: 21912,
        name: 'Kornelimünster/Walheim',
        lat: 50.70367,
        lng: 6.16924,
      },
      {
        id: 21920,
        name: 'Laurensberg',
        lat: 50.79274,
        lng: 6.03938,
      },
      {
        id: 21919,
        name: 'Richterich',
        lat: 50.83067,
        lng: 6.04769,
      },
    ],
  },
  Braunschweig: {
    ags: '03101000',
    areas: [
      {
        id: 2429548,
        name: 'Braunschweig-Süd',
        lat: 52.21348,
        lng: 10.52244,
      },
      {
        id: 7723,
        name: 'Hondelage-Volkmarode',
        lat: 52.30146,
        lng: 10.60714,
      },
      {
        id: 3407571,
        name: 'Lehndorf-Watenbüttel',
        lat: 52.2914,
        lng: 10.45594,
      },
      {
        id: 2419928,
        name: 'Mitte',
        lat: 52.25476,
        lng: 10.5397,
      },
      {
        id: 3407584,
        name: 'Nördliche Schunter-/Okeraue',
        lat: 52.32475,
        lng: 10.49977,
      },
      {
        id: 2420045,
        name: 'Nordstadt-Schunteraue',
        lat: 52.29179,
        lng: 10.53059,
      },
      {
        id: 2419753,
        name: 'Östliches Ringgebiet',
        lat: 52.26723,
        lng: 10.55171,
      },
      {
        id: 2429741,
        name: 'Südstadt-Rautheim-Mascherode',
        lat: 52.22953,
        lng: 10.56968,
      },
      {
        id: 2375725,
        name: 'Südwest',
        lat: 52.22507,
        lng: 10.46567,
      },
      {
        id: 3407262,
        name: 'Wabe-Schunter-Beberbach',
        lat: 52.30606,
        lng: 10.56995,
      },
      {
        id: 2341897,
        name: 'Westliches Ringgebiet',
        lat: 52.25895,
        lng: 10.50298,
      },
      {
        id: 2414966,
        name: 'Weststadt',
        lat: 52.24979,
        lng: 10.48062,
      },
    ],
  },
  Krefeld: {
    ags: '05114000',
    areas: [
      {
        id: 18735289,
        name: 'Krefeld-Fischeln',
        lat: 51.30118,
        lng: 6.57983,
      },
      {
        id: 18733365,
        name: 'Krefeld-Hüls',
        lat: 51.37535,
        lng: 6.51636,
      },
      {
        id: 18735122,
        name: 'Krefeld-Mitte',
        lat: 51.33512,
        lng: 6.57026,
      },
      {
        id: 18734965,
        name: 'Krefeld-Nord',
        lat: 51.35235,
        lng: 6.54911,
      },
      {
        id: 18734938,
        name: 'Krefeld-Oppum-Linn',
        lat: 51.32997,
        lng: 6.62797,
      },
      {
        id: 18734811,
        name: 'Krefeld-Ost',
        lat: 51.36841,
        lng: 6.59684,
      },
      {
        id: 18735269,
        name: 'Krefeld-Süd',
        lat: 51.3202,
        lng: 6.56866,
      },
      {
        id: 18734519,
        name: 'Krefeld-Uerdingen',
        lat: 51.34871,
        lng: 6.65778,
      },
      {
        id: 18734434,
        name: 'Krefeld-West',
        lat: 51.3185,
        lng: 6.52695,
      },
    ],
  },
  Mainz: {
    ags: '07315000',
    areas: [
      {
        id: 4565219,
        name: 'Altstadt',
        lat: 49.99927,
        lng: 8.27565,
      },
      {
        id: 4565116,
        name: 'Bretzenheim',
        lat: 49.97531,
        lng: 8.23442,
      },
      {
        id: 4564413,
        name: 'Drais',
        lat: 49.97299,
        lng: 8.19345,
      },
      {
        id: 4565454,
        name: 'Ebersheim',
        lat: 49.91933,
        lng: 8.24761,
      },
      {
        id: 4564335,
        name: 'Finthen',
        lat: 49.98429,
        lng: 8.16726,
      },
      {
        id: 4560789,
        name: 'Gonsenheim',
        lat: 49.99987,
        lng: 8.20735,
      },
      {
        id: 4547576,
        name: 'Hartenberg-Münchfeld',
        lat: 50.00274,
        lng: 8.24168,
      },
      {
        id: 4565444,
        name: 'Hechtsheim',
        lat: 49.95436,
        lng: 8.271,
      },
      {
        id: 4565425,
        name: 'Laubenheim',
        lat: 49.95555,
        lng: 8.31786,
      },
      {
        id: 4564449,
        name: 'Lerchenberg',
        lat: 49.96085,
        lng: 8.19822,
      },
      {
        id: 4564545,
        name: 'Marienborn',
        lat: 49.95808,
        lng: 8.22603,
      },
      {
        id: 4555036,
        name: 'Mombach',
        lat: 50.02204,
        lng: 8.21647,
      },
      {
        id: 4547573,
        name: 'Neustadt',
        lat: 50.01672,
        lng: 8.25083,
      },
      {
        id: 4565165,
        name: 'Oberstadt',
        lat: 49.98852,
        lng: 8.26427,
      },
      {
        id: 4565357,
        name: 'Weisenau',
        lat: 49.97699,
        lng: 8.30073,
      },
    ],
  },
  Lübeck: {
    ags: '01003000',
    areas: [
      {
        id: 367837,
        name: 'Buntekuh',
        lat: 53.85566,
        lng: 10.63282,
      },
      {
        id: 367855,
        name: 'Innenstadt',
        lat: 53.86649,
        lng: 10.68573,
      },
      {
        id: 367873,
        name: 'Kücknitz',
        lat: 53.91612,
        lng: 10.80236,
      },
      {
        id: 367870,
        name: 'Moisling',
        lat: 53.82967,
        lng: 10.60186,
      },
      {
        id: 367872,
        name: 'Sankt Gertrud',
        lat: 53.87664,
        lng: 10.73217,
      },
      {
        id: 367868,
        name: 'Sankt Jürgen',
        lat: 53.81523,
        lng: 10.67407,
      },
      {
        id: 367871,
        name: 'Sankt Lorenz Nord',
        lat: 53.87911,
        lng: 10.63808,
      },
      {
        id: 367854,
        name: 'Sankt Lorenz Süd',
        lat: 53.85777,
        lng: 10.66561,
      },
      {
        id: 367835,
        name: 'Schlutup',
        lat: 53.88713,
        lng: 10.77664,
      },
      {
        id: 367874,
        name: 'Travemünde',
        lat: 53.94089,
        lng: 10.87326,
      },
    ],
  },
};
